import { SliceCaseReducers, ValidateSliceCaseReducers, createSlice } from '@reduxjs/toolkit';

import { SliceReducers, ValidateSliceReducers } from './create-app-slice.types';

export const createAppSlice = <T, Reducers extends SliceReducers<T>>({
  name,
  initialState,
  reducers,
}: {
  name: string;
  initialState: T;
  reducers: ValidateSliceReducers<T, Reducers>;
}) => {
  return createSlice({
    name,
    initialState,
    reducers: reducers as ValidateSliceCaseReducers<T, SliceCaseReducers<T>>,
  });
};
